export function getWorkspacesLink(page: number = 1) {
  return `/workspaces?page=${page}`
}
